import { useMutation } from "@apollo/client";
import {
  DELETE_APPEARANCE,
  GET_APPEARANCES_BY_MATCH_ID,
  APPEARANCES_WITH_PERMISSION,
} from "../../GraphQL/Appearances";
import useNotification from "../../hooks/useNotification.js";
import ConfirmDeleteDialog from "../UI/ConfirmDeleteDialog.js";

const DeleteAppearanceDialog = (props) => {
  const { notifySuccess } = useNotification();

  const [deleteAppearance, { loading, error }] = useMutation(DELETE_APPEARANCE, {
    variables: { id: props.appearance.id },
    refetchQueries: [GET_APPEARANCES_BY_MATCH_ID, APPEARANCES_WITH_PERMISSION],
    onCompleted: () => {
      notifySuccess("Appearance deleted.");
      props.setOpen(false);
    },
  });

  return (
    <ConfirmDeleteDialog
      open={props.open}
      setOpen={props.setOpen}
      entityName={props.appearance.player.name}
      onConfirm={deleteAppearance}
      loading={loading}
      error={error}
      confirmTestId="saveDeleteAppearanceDialogButton"
      cancelTestId="closeDeleteAppearanceDialogButton"
    />
  );
};

export default DeleteAppearanceDialog;
